import { Button, Drawer, Input, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
// import axios from "axios";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
// import { baseUrl } from "../../../../components/common/baseUrl";
import { useNotify } from "../../../../components/Notification";
// import { settings } from "../../../../utils/config";
import { permissionAPIWithErrorHandling } from "../../../../api/admin/permission";
import { neutral, spacing } from "../../../../theme/tokens";

const PermissionForm = (props) => {
  const { isOpen, onOk, onCancel, hookForm } = props;
  // const hasAccessToken = settings?.getCookie("access_token");
  const notify = useNotify();

  const [listParent, setListParent] = useState([]);

  const fetchActions = async () => {
    try {
      // const url = `${baseUrl}/api/v1/security/permissions/permission-parent`;
      // const response = await axios.get(url, {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${hasAccessToken}`,
      //   },
      // });
      
      const response = await permissionAPIWithErrorHandling.permissionParent();

      if (response.data.success && response.data.data) {
        const result = response.data.data;

        setListParent(
          result.map((item) => ({ label: item.label, value: item.id })) || []
        );
      }
    } catch (error) {
      notify.error({
        message: "Thất bại",
        description: error.response.data?.message,
      });
    } finally {
    }
  };

  useEffect(() => {
    fetchActions();
  }, []);
  return (
    <>
      <Drawer
        title="Thêm permission"
        placement="right"
        width="min(560px, 100vw)"
        open={isOpen}
        onClose={onCancel}
        destroyOnClose
        styles={{ body: { background: neutral[50], padding: spacing[6] } }}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: spacing[2] }}>
            <Button onClick={onCancel}>Hủy</Button>
            <Button type="primary" onClick={hookForm?.handleSubmit(onOk)}>
              Thêm mới
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: 16 }}>
          <label style={{ marginBottom: 8, display: "block" }}>
            Mã permission <span style={{ color: "red" }}>*</span>
          </label>
          <Controller
            name="name"
            control={hookForm.control}
            rules={{ required: "Mã permission không được bỏ trống" }}
            render={({ field }) => (
              <Input {...field} placeholder="Mã permission" />
            )}
          />
          {hookForm?.formState?.errors?.name && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {hookForm.formState.errors.name.message}
            </span>
          )}
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ marginBottom: 8, display: "block" }}>
            Permission cha
          </label>
          <Controller
            name="parent_id"
            control={hookForm.control}
            render={({ field }) => (
              <Select
                {...field}
                showSearch
                style={{ width: "100%" }}
                placeholder="Chọn permission cha"
                optionFilterProp="label"
                options={listParent}
              />
            )}
          />
          {hookForm?.formState?.errors?.name && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {hookForm.formState.errors.name.message}
            </span>
          )}
        </div>
        <div>
          <label style={{ marginBottom: 8, display: "block" }}>
            Mô tả
            <span style={{ color: "red", marginBottom: "10px" }}>*</span>
          </label>
          <Controller
            name="label"
            control={hookForm.control}
            rules={{ required: "Mô tả không được bỏ trống" }}
            render={({ field }) => (
              <TextArea {...field} placeholder="Mô tả" size="large" />
            )}
          />
          {hookForm?.formState?.errors?.label && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {hookForm.formState.errors.label.message}
            </span>
          )}
        </div>
      </Drawer>
    </>
  );
};
export default PermissionForm;
